export default "__VITE_ASSET__506fa52b__"